// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

export function EnumDisplayNamesToArray(enums) {
    const StringIsNumber = (value) => isNaN(Number(value)) === false;
    return Object.keys(enums)
        .filter(StringIsNumber)
        .map((key) => enums[key]);
}

export function EnumValuesToArray(enums) {
    const StringIsNumber = (value) => isNaN(Number(value)) === true;
    return Object.keys(enums)
        .filter(StringIsNumber)
        .map((key) => enums[key]);
}
